import { StageInterface } from "@/v2/types/StageInterface";

const calculateStageRevenuePerStatus = (stages: StageInterface[]) => {
  if (!stages || !Array.isArray(stages) || stages.length === 0) {
    return {
      total: 0,
      available: 0,
      hold: 0,
      underContract: 0,
      settled: 0,
      notReleased: 0,
      unconditional: 0,
    };
  }

  return stages.reduce(
    (totals, stage) => {
      totals.total += stage.revenue.total;
      totals.available += stage.revenue.available;
      totals.hold += stage.revenue.hold;
      totals.underContract += stage.revenue.underContract;
      totals.settled += stage.revenue.settled;
      totals.notReleased += stage.revenue.notReleased;
      totals.unconditional += stage.revenue.unconditional;
      return totals;
    },
    {
      total: 0,
      available: 0,
      hold: 0,
      underContract: 0,
      settled: 0,
      notReleased: 0,
      unconditional: 0,
    }
  );
};

export default calculateStageRevenuePerStatus;
